import React from "react";
import "./NewFeatured.css";

function NewFeatured() {
  return (
    <div className="new-featured">
      <h1 >As Featured In:</h1>
      <div className="logo-box">
        {/* <a
          href="https://www.thisdaylive.com/index.php/2023/01/05/pennytrees-new-app-is-designed-for-individuals-merchants-to-thrive-says-pennytree-co-founder/"
          target="blank"
        >
          <img
            src="/assets/business_day-removebg-preview 1.png"
            alt=""
            className="featured-paper-img"
          />
        </a> */}
        {/* <a
          href="https://guardian.ng/news/pennytree-launches-new-app-to-enhance-retail-banking-services/"
          target="blank"
        >
          <img
            src="https://res.cloudinary.com/teb/image/upload/v1670502171/guardian-removebg-preview_e5blox.png"
            alt=""
            className="featured-paper-img"
          />
        </a> */}
        <a
          href="https://businessday.ng/news/article/pennytree-in-pact-with-vfd-to-offer-seamless-payment-system-to-businesses/"
          target="blank"
        >
          <img
            src="/assets/business_day-removebg-preview 1.png"
            alt=""
            className="featured-paper-img"
          />
        </a>

        <a
          href="https://punchng.com/fintech-firm-launches-retail-banking-app/"
          target="blank"
        >
          <img
            src="/assets/vanguard-removebg-preview 1.png"
            alt=""
            className="featured-paper-img"
          />
        </a>
        <a
          href="https://punchng.com/fintech-firm-launches-retail-banking-app/"
          target="blank"
        >
          <img
            src="/assets/Technext-Logo-2022-01 1.png"
            alt=""
            className="featured-paper-img"
          />
        </a>
      </div>
    </div>
  );
}

export default NewFeatured;
